module.exports = __webpack_public_path__ + "components/flag/static/square/bo-3c933b7770e6179634040ee4eaadfe3c.svg";